import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { space } from '../../mixins';

import Icon from '../Icon/Icon';
import Text from '../Text/Text';

import withValidation from '../../hocs/withValidation';

const Wrapper = styled.label`
  position: relative;
  ${space};
  line-height: 17px;
  font-size: 15px;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  display: flex;
`;

const Input = styled.input`
  position: absolute;
  width: 0;
  height: 0;
  opacity: ${props => props.theme.opacity.full};
`;

const Label = styled(Text)`
  line-height: 17px;
  font-size: 15px;
  width: 100%;
  color: ${props =>
    props.disabled
      ? props.theme.elem.checkbox.disabledLabel
      : props.theme.colors.black};
`;

const checkedStyles = css`
  background-color: ${props =>
    props.disabled
      ? props.theme.elem.checkbox.disabledCheckedBg
      : props.theme.colors.brand};
`;

// TODO: Refactoring, remove icons, css only
const CheckboxIcon = styled(Icon).attrs({
  icon: props =>
    !props.checked
      ? props.active
        ? 'checkboxFocus'
        : props.hasError ? 'checkboxError' : 'checkboxEmpty'
      : props.disabled ? 'checkboxCheckedDisabled' : 'checkboxChecked',
  height: '14px',
  width: '14px'
})`
  flex-shrink: 0;
  margin-right: 7px;
  margin-top: 2px;
  box-sizing: border-box;
  border-radius: 4px;
  ${props => (props.checked ? checkedStyles : null)};
  ${props =>
    props.active
      ? css`
          box-shadow: 0 2px 4px 0 rgba(36, 75, 137, 0.25);
        `
      : null};
`;

class Checkbox extends React.Component {
  stopPropagation = event => {
    event.stopPropagation();
  };

  render() {
    const {
      checked,
      name,
      disabled,
      active,
      onChange,
      hasError,
      ...styledProps
    } = this.props;

    return (
      <Wrapper
        disabled={disabled}
        onClick={this.stopPropagation}
        className={`field-checkbox-${name}`}
        {...styledProps}
      >
        <Input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          className={`field-checkbox-${name}`}
        />
        <CheckboxIcon
          checked={checked}
          active={active}
          disabled={disabled}
          label={this.props.label}
          hasError={hasError}
          className="checkbox-icon"
        />
        {this.props.label && (
          <Label disabled={disabled}>{this.props.label}</Label>
        )}
      </Wrapper>
    );
  }
}

Checkbox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  checked: PropTypes.bool,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  hasError: PropTypes.bool
};

Checkbox.defaultProps = {
  name: '',
  label: '',
  checked: false,
  active: false,
  disabled: false,
  onChange: null,
  hasError: false
};

export default withValidation(Checkbox, 'checkbox');



// WEBPACK FOOTER //
// ./src/components/units/Checkbox/Checkbox.js